import * as React from "react";
import { forwardRef } from "react";
const SvgInfo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 21, viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10 14.7707V14.729M10 12.6873C10 10.1373 12.5 11.3165 12.5 8.767C12.5 5.383 7.5 5.383 7.5 8.767", stroke: "#818288", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 9.99935, cy: 10.4998, r: 7.73333, stroke: "#818288", strokeWidth: 1.2 }));
const ForwardRef = forwardRef(SvgInfo);
export { ForwardRef as ReactComponent };
